import React from "react";

const SearchIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.7142 18L11.4642 12.75C11.0475 13.0833 10.5684 13.3472 10.0267 13.5417C9.48503 13.7361 8.90864 13.8333 8.29753 13.8333C6.78364 13.8333 5.50239 13.309 4.45378 12.2604C3.40516 11.2118 2.88086 9.93056 2.88086 8.41667C2.88086 6.90278 3.40516 5.62153 4.45378 4.57292C5.50239 3.52431 6.78364 3 8.29753 3C9.81142 3 11.0927 3.52431 12.1413 4.57292C13.1899 5.62153 13.7142 6.90278 13.7142 8.41667C13.7142 9.02778 13.617 9.60417 13.4225 10.1458C13.2281 10.6875 12.9642 11.1667 12.6309 11.5833L17.8809 16.8333L16.7142 18ZM8.29753 12.1667C9.33919 12.1667 10.2246 11.8021 10.9538 11.0729C11.6829 10.3438 12.0475 9.45833 12.0475 8.41667C12.0475 7.375 11.6829 6.48958 10.9538 5.76042C10.2246 5.03125 9.33919 4.66667 8.29753 4.66667C7.25586 4.66667 6.37044 5.03125 5.64128 5.76042C4.91211 6.48958 4.54753 7.375 4.54753 8.41667C4.54753 9.45833 4.91211 10.3438 5.64128 11.0729C6.37044 11.8021 7.25586 12.1667 8.29753 12.1667Z"
        fill="#D9D9D9"
      />
    </svg>
  );
};

export default SearchIcon;
